import { render, staticRenderFns } from "./PersonalTaxReturnFilingAcknowledgement.vue?vue&type=template&id=d7800606"
import script from "./PersonalTaxReturnFilingAcknowledgement.vue?vue&type=script&lang=js"
export * from "./PersonalTaxReturnFilingAcknowledgement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports